var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('input',{attrs:{"type":"button","value":"行政區"},on:{"click":function($event){return _vm.switchLayer(_vm.openLayers.Layer.CropAlert,true)}}})]),_c('div',{attrs:{"id":"map"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }